import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { initGA, trackPageView } from "./analytics";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { v4 as uuidv4 } from "uuid";
import "./App.css";
import API_BASE_URL from "./services/apiClient";
// import  { Helmet } from "react-helmet-async"
/* ===== COMPONENT IMPORTS ===== */
import SignIn from "./components/SignIn";
// import TripResults from "./components/TripResults";
// import ProfilePage from "./components/ProfilePage";
// import ItineraryPage from "./components/ItineraryPage";
// import ItineraryDetail from "./components/ItineraryDetail";
// import SavedItineraries from "./components/SavedItineraries";
// import PackingList from "./components/PackingList";
import ItinerarySlider from "./components/ItinerarySlider";
// import BlogDetail from "./components/BlogDetail";
// import Blogs from "./components/Blogs";
// import AdminBlog from "./components/AdminBlog";
import FeatureCards from "./components/FeatureCards";
// import DistanceCalculator from "./components/DistanceCalculator";
// import ExploreCities from "./components/ExploreCities";
// import CityPage from "./components/CityPage";
import AiFeedbackBanner from "./components/AifeedbackBanner";
import TripsDashboard from "./components/TripsDashboard";
// import BecomeGuide from "./components/BecomeGuide";
// import { demoItinerary } from "./data/demoItineraries";
import { generateTravelItinerary } from "./services/api";
// import AiFailPage from "./components/AiFaliPage";
import AppRouter from "./AppRouter";
// import QuizPage from "./pages/QuizPage";
// import { logTokenChange } from "./services/api";
import LogoLoader from "./components/LogoLoader";
import FreeGenerationPopup from "./components/FreeGenerationsPopup";
import CitySlider from "./components/CitySlider";
import { buildPrompt } from "./services/prompts/buildPrompt";
import PlanPage from "./pages/TripPlanner";
import heroImage from "./assets/illustrations/bg1.webp";
import img8 from "./assets/illustrations/global-team.svg";
import floatingImg from "./assets/illustrations/floatingImg.svg";
import CreatorDashboardSection from "./pages/curator/CreatorDashboardSection";
import FaqFooterSection from "./components/FaqFooterSection";
// import Footer from "./components/Footer";

function App() {

  const API_URL = process.env.REACT_APP_API_URL;

// const isLoggedIn = !!localStorage.getItem("token");



  // 🔥 Guarantee guestId immediately
  if (!localStorage.getItem("guestId")) {
    localStorage.setItem("guestId", uuidv4());
  }

  const navigate = useNavigate();
  /* ================= ROUTER ================= */

  const location = useLocation();
  // 🔥 Google Analytics
  useEffect(() => {
    initGA();
  }, []);



  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  useEffect(() => {
  const openLoginListener = () => {
    setShowSignIn(true);
  };

  window.addEventListener("openLogin", openLoginListener);

  return () => {
    window.removeEventListener("openLogin", openLoginListener);
  };
}, []);


  /* ================= STATE ================= */
  // const [activeComponent, setActiveComponent] = useState("home");
  const [showSignIn, setShowSignIn] = useState(false);
  const [loading, setLoading] = useState(false);

  // const [selectedItineraryId, setSelectedItineraryId] = useState(null);
  // const [selectedBlogSlug, setSelectedBlogSlug] = useState(null);
  // const [selectedCity, setSelectedCity] = useState(null);
  // const [showBecomeGuide, setShowBecomeGuide] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showFreePopup, setShowFreePopup] = useState(false);
  const [freeRemaining, setFreeRemaining] = useState(null);
  //const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  /* ================= REFS ================= */
  const formCardRef = useRef(null);
  const [popupMessage, setPopupMessage] = useState("");
  /* ================= AI ================= */
  const [apiStatus, setApiStatus] = useState("checking");
  /* ================= USER ================= */
  const [tripDate, setTripDate] = useState("");

  const [currentUser, setCurrentUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [multiStartDate, setMultiStartDate] = useState("");


  const ENABLE_CREATOR_DASHBOARD = true;
  
  const loadingRef = useRef(false);
  useGoogleOneTapLogin({
  disabled: !!currentUser,

  onSuccess: async (credentialResponse) => {
    try {
      const res = await fetch(`${API_URL}/api/auth/google-popup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_token: credentialResponse.credential,
        }),
      });

      const data = await res.json();

      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      window.location.reload();
    } catch (err) {
      console.error("One Tap login failed", err);
    }
  },
});
  useEffect(() => {
    let isMounted = true;

    const checkApiStatus = async () => {
      try {
        const res = await fetch(`${API_URL}/api/health`);

        if (!res.ok) throw new Error("API down");

        if (isMounted) setApiStatus("available");
      } catch (err) {
        if (isMounted) setApiStatus("offline");
      }
    };

    checkApiStatus();

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  useEffect(() => {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    // 🔹 No token → stop loading
    if (!token) {
      setAuthLoading(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Auth failed");
        return res.json();
      })
      .then((user) => {
        const safeUser =
          user.role === "admin"
            ? { ...user, tokens: Infinity }
            : user;

        setCurrentUser(safeUser);
        localStorage.setItem("user", JSON.stringify(safeUser));
      })
      .catch(() => {
        // ❌ Invalid / expired token
        localStorage.clear();
        sessionStorage.clear();
        setCurrentUser(null);
      })
      .finally(() => {
        // 🔥 ALWAYS stop loader
        setAuthLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);





  /* ================= FORM ================= */
  const [tripType, setTripType] = useState("multi");
  const [days, setDays] = useState(3);
  const [hours, setHours] = useState(4);
  const [place, setPlace] = useState("");
  const [group, setGroup] = useState("Family");
  // const [budget, setBudget] = useState("Medium");
  // const [Transport, setTransport] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // const [step, setStep] = useState(1);
  // const [travelDate, setTravelDate] = useState("");

  /* ================= AI ================= */

  /* ================= URL → STATE SYNC ================= */
  //  useEffect(() => {
  //   const path = location.pathname;

  //   if (path === "/") setActiveComponent("home");
  //   else if (path === "/cities") setActiveComponent("cities");
  //   else if (path.startsWith("/cities/")) {
  //     setSelectedCity(path.split("/")[2]);
  //     setActiveComponent("city");
  //   }
  //   else if (path === "/itineraries") setActiveComponent("itineraries");
  //   else if (path.startsWith("/itineraries/")) {
  //     setSelectedItineraryId(path.split("/")[2]);
  //     setActiveComponent("itinerary-detail");
  //   }
  //   else if (path === "/packing") setActiveComponent("packing");
  //   else if (path === "/become-guide") setActiveComponent("become-guide");
  //   else if (path === "/ai-failed") setActiveComponent("ai-failed");

  // }, [location.pathname]);



  useEffect(() => {
    const timeout = setTimeout(async () => {
      if (!place || place.length < 3) {
        setCitySuggestions([]);
        return;
      }

      try {
        const res = await fetch(
          `https://secure.geonames.org/searchJSON?name_startsWith=${place}&maxRows=6&cities=cities15000&username=praseed`
        );

        const data = await res.json();
        setCitySuggestions(data.geonames || []);
      } catch (err) {
        console.error("GeoNames error", err);
      }
    }, 400); // debounce

    return () => clearTimeout(timeout);
  }, [place]);

  const addSuggestion = (text) => {
    setSuggestions((prev) => {
      if (!prev) return text;
      if (prev.toLowerCase().includes(text.toLowerCase())) return prev;
      return prev + ", " + text;
    });
  };






  /* ================= AUTH ================= */
  const handleLoginSuccess = (user) => {
    const safeUser =
      user.role === "admin"
        ? { ...user, tokens: Infinity }
        : user;

    setCurrentUser(safeUser);

    // 🎯 Dynamic popup message
    setPopupMessage(
      ` Welcome to Expeditio! You have ${safeUser.tokens} travel tokens.`
    );

    setShowLoginPopup(true);

    setTimeout(() => {
      setShowLoginPopup(false);
    }, 3000);

     // 🚀 NEW: auto join trip after login
  const pendingToken = localStorage.getItem("pendingTripJoin");

  if (pendingToken) {
    localStorage.removeItem("pendingTripJoin");

    navigate(`/join/${pendingToken}`);
  }
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    setCurrentUser(null);

    setPopupMessage(" You’ve been logged out successfully.");

    setShowLoginPopup(true);

    setTimeout(() => {
      setShowLoginPopup(false);
    }, 2000);

    navigate("/");
  };


const runGeneration = async () => {
  if (loadingRef.current) return;

  loadingRef.current = true;
  setLoading(true);

  try {
    const cleanedPlace = place.trim();

    /* ================= VALIDATION ================= */
    if (!cleanedPlace) {
      throw new Error("Please enter a destination");
    }

    if (tripType === "day" && !tripDate) {
      throw new Error("Please select a travel date");
    }

    if (tripType === "multi" && !multiStartDate) {
      throw new Error("Please select a start date");
    }

    /* ================= WEATHER ================= */
    let weatherData = null;

    try {
      const dateToUse =
        tripType === "day" ? tripDate : multiStartDate;

      if (dateToUse) {
        const weatherRes = await fetch(
          `${API_BASE_URL}/api/weather?city=${encodeURIComponent(
            cleanedPlace
          )}&date=${dateToUse}`
        );

        if (weatherRes.ok) {
          weatherData = await weatherRes.json();
        }
      }
    } catch (err) {
      console.log("Weather skipped:", err.message);
    }

    /* ================= PROMPT ================= */
    const prompt = buildPrompt({
      tripType,
      place: cleanedPlace,
      hours,
      days,
      group,
      suggestions,
      weatherData,
      tripDate,
    });

    /* ================= AI CALL (WITH RETRY) ================= */
    let aiResponse = null;

    for (let i = 0; i < 2; i++) {
      try {
        aiResponse = await generateTravelItinerary(prompt);
        if (aiResponse) break;
      } catch (err) {
        console.log("AI attempt failed:", i + 1);
      }
    }

    /* ================= AI FAIL ================= */
    if (!aiResponse) {
      throw new Error("AI_SERVICE_DOWN");
    }

    if (!aiResponse.text || aiResponse.text.length < 20) {
      throw new Error("AI_EMPTY");
    }

    /* ================= GUEST LIMIT ================= */
    if (!currentUser && typeof aiResponse.remainingFree === "number") {
      setFreeRemaining(aiResponse.remainingFree);

      if (aiResponse.remainingFree <= 1) {
        setShowFreePopup(true);
      }
    }

    /* ================= TOKEN UPDATE ================= */
    if (
      currentUser &&
      currentUser.role !== "admin" &&
      typeof aiResponse.remainingTokens === "number"
    ) {
      const updatedUser = {
        ...currentUser,
        tokens: aiResponse.remainingTokens,
      };

      const storage =
        localStorage.getItem("user") ? localStorage : sessionStorage;

      storage.setItem("user", JSON.stringify(updatedUser));
      setCurrentUser(updatedUser);
    }

    /* ================= SAVE RESULT ================= */
    const result = { text: aiResponse.text };

    localStorage.setItem("lastTripResult", JSON.stringify(result));

    navigate("/results", {
      state: {
        suggestions: result,
        city: cleanedPlace,
        tripType,
        weather: weatherData || null,
        tripDate: tripDate || null,
        startDate: multiStartDate || null,
      },
    });

  } catch (err) {
    console.error("AI ERROR:", err);

    /* ================= HANDLE BACKEND ERRORS ================= */

    // 🔥 Guest limit reached
    if (err?.status === 429 || err?.code === "GUEST_LIMIT") {
      setFreeRemaining(0);
      setShowFreePopup(true);
      return;
    }

    // 🔥 Token exhausted
    if (err?.status === 403 || err?.code === "NO_TOKENS") {
      navigate("/quiz");
      return;
    }

    // 🔥 AI service down / network fail
    if (
      err.message === "AI_SERVICE_DOWN" ||
      err.message?.includes("Failed to fetch") ||
      err.message?.includes("Network")
    ) {
      navigate("/ai-failed", {
        state: { reason: "AI service unavailable" },
      });
      return;
    }

    // 🔥 Validation errors (user input)
    if (
      err.message &&
      err.message !== "AI_EMPTY"
    ) {
      alert(err.message);
      return;
    }

    // 🔥 AI returned weak/invalid response
    if (err.message === "AI_EMPTY") {
      navigate("/ai-failed", {
        state: { reason: "AI could not generate a proper itinerary" },
      });
      return;
    }

    // 🔥 fallback
    navigate("/ai-failed", {
      state: { reason: err.message || "Something went wrong" },
    });

  } finally {
    loadingRef.current = false;
    setLoading(false);
  }
};

  /* ================= SUBMIT ================= */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    runGeneration();
  };

  /* ================= RENDER PAGE ================= */


  return (



    <div className="App min-h-screen">
      {/* ✅ LOGIN SUCCESS POPUP */}
      {showLoginPopup && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            background: popupMessage.includes("logged")
              ? "#374151"
              : "linear-gradient(135deg, #5b7c67, #4a6a58)",
            color: "#fff",
            padding: "16px 22px",
            borderRadius: "14px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
            zIndex: 9999,
            fontSize: "14px",
            animation: "slideIn 0.4s ease-out",
          }}
        >
          {popupMessage}
        </div>
      )}
      {authLoading && <LogoLoader />}

      {loading && <LogoLoader />}

      {/* ===== SIGN IN MODAL ===== */}
      {showSignIn && (
        <SignIn
          onClose={() => setShowSignIn(false)}
          onLoginSuccess={handleLoginSuccess}
        />
      )}

      {showFreePopup && !currentUser && (
        <FreeGenerationPopup
          remaining={freeRemaining}
          onClose={() => setShowFreePopup(false)}
          onContinue={() => {
            setShowFreePopup(false);
          }}
        />
      )}

      {/* ===== ROUTER ===== */}
      <AppRouter
        currentUser={currentUser}
        handleLogout={handleLogout}
        navigate={navigate}
        openLogin={() => setShowSignIn(true)}
        // QUICK FIX: Pass your entire Home logic as a prop so variables stay linked
        homeContent={
          <>
            {/* HERO SECTION */}
  <div className="relative max-w-7xl mx-auto mt-4 md:mt-14 px-2 md:px-4">

  
 {/* ================= MOBILE ================= */}
<div className="block md:hidden relative">

  {/* ===== FULL BLEED HERO ===== */}
  <div className="relative left-1/2 right-1/2 -mx-[50vw] w-screen min-h-[80vh] overflow-hidden">

    {/* Background Image */}
    <img
      src={heroImage}
      alt="Travel"
      className="absolute inset-0 w-full h-full object-cover scale-110"
    />

    {/* Cinematic Overlay */}
    <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70 backdrop-blur-[4px]" />

    {/* Smooth fade into form */}
    <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-[#f7f6f1] to-transparent" />

    {/* HERO CONTENT */}
<div className="
  relative z-10
  h-full
  flex flex-col
  justify-start
  items-start
  text-left
  px-7
  pt-[78px]
">
     

      <div className="mb-5 text-[12px] tracking-[0.28em] uppercase text-white/70 font-semibold">
        PLAN • MANAGE • SHARE • TRAVEL
      </div>

   <h1 className="
  font-serif
  text-[58px]
  leading-[0.88]
  tracking-[-0.05em]
  font-medium
  text-white
  drop-shadow-[0_4px_20px_rgba(0,0,0,0.35)]
">
  Your next trip,
  <br />

  <span className="text-[#dce775] italic font-medium">
    beautifully
  </span>

  <br />

  <span className="text-[#dce775] italic font-medium">
    organized.
  </span>
</h1>

<p className="
  mt-8
  text-[17px]
  text-white
  leading-[1.6]
  max-w-[320px]
  font-small
  drop-shadow-md
">
  AI-powered itineraries, smart planning, and beautiful trips your friends actually want to join.
</p>


      
<a
  href="#plan-form"
  onClick={(e) => {
    e.preventDefault();

    const target = document.getElementById("plan-form");
    if (!target) return;

    const targetY = target.getBoundingClientRect().top + window.scrollY;

    const startY = window.scrollY;
    const distance = targetY - startY;
    const duration = 600; // 👈 control smoothness (bigger = slower)
    let startTime = null;

    function smoothScroll(currentTime) {
      if (!startTime) startTime = currentTime;
      const time = currentTime - startTime;

      const progress = Math.min(time / duration, 1);

      // easeInOut (super smooth)
      const ease =
        progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

      window.scrollTo(0, startY + distance * ease);

      if (time < duration) {
        requestAnimationFrame(smoothScroll);
      }
    }

    requestAnimationFrame(smoothScroll);
  }}
  className="mt-14 w-full block text-center rounded-full bg-[#5b6f00] px-8 py-4 text-lg font-bold text-white shadow-[0_20px_50px_rgba(0,0,0,0.35)] hover:scale-[1.02] active:scale-95 transition-all"
>
  Start Planning
</a>

<div className="flex items-center  gap-5">

 <div className="mt-8 flex items-center gap-4">

  <img
    src={img8}
    alt="Travelers"
    className="w-[74px] opacity-90 drop-shadow-md"
  />

  <p className="
    text-[14px]
    text-white/85
    font-medium
    leading-snug
    max-w-[180px]
  ">
    Trusted by{" "}
    <span className="text-white font-semibold">
      3k+ travelers
    </span>{" "}
    & creators
  </p>

</div>

 

</div>

    </div>
  </div>


 
{/* ===== CLEAN CONNECTED FORM ===== */}
<div
id="plan-form"
  ref={formCardRef}
  className="-mt-16 relative z-40 scroll-mt-24"
>
 

    <PlanPage
      formCardRef={formCardRef}
      handleSubmit={handleSubmit}
      tripType={tripType}
      setTripType={setTripType}
      hours={hours}
      setHours={setHours}
      days={days}
      setDays={setDays}
      multiStartDate={multiStartDate}
      setMultiStartDate={setMultiStartDate}
      place={place}
      setPlace={setPlace}
      group={group}
      setGroup={setGroup}
      suggestions={suggestions}
      setSuggestions={setSuggestions}
      addSuggestion={addSuggestion}
      loading={loading}
      citySuggestions={citySuggestions}
      showSuggestions={showSuggestions}
      setShowSuggestions={setShowSuggestions}
      tripDate={tripDate}
      setTripDate={setTripDate}
    />

 
</div>
</div>



  {/* ================= DESKTOP ================= */}
  <div className="relative hidden md:grid md:grid-cols-[1fr_1.35fr] gap-12 items-center mb-20 overflow-hidden">

{/* DESKTOP BACKGROUND IMAGE */}
{/* DESKTOP BACKGROUND IMAGE */}
<div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-screen z-0 pointer-events-none overflow-hidden">
  {/* IMAGE */}
  <img
    src={floatingImg}
    alt="Background Texture"
   className="
  absolute
  left-[-280px]
  top-0
  
  w-[120vw]
  h-full
  object-contain
  opacity-[0.78]
  scale-[1.08]
  
  mix-blend-multiply
  
"
   />

{/* LEFT FADE */}
<div
  className="
    absolute
    inset-y-0
    left-0
    w-[55%]
    bg-gradient-to-r
    from-[#f7f6f1]
    via-[#f7f6f1]
    via-[#f7f6f1]/98
    via-[#f7f6f1]/92
    via-[#f7f6f1]/75
    via-[#f7f6f1]/40
    to-transparent
    z-20
    pointer-events-none
  "
/>

{/* TOP FADE */}
<div
  className="
    absolute
    top-0
    left-0
    w-full
    h-[22%]
    bg-gradient-to-b
    from-[#f7f6f1]
    via-[#f7f6f1]/95
    via-[#f7f6f1]/70
    to-transparent
    z-20
    pointer-events-none
  "
/>

{/* BOTTOM FADE */}
<div
  className="
    absolute
    bottom-0
    left-0
    w-full
    h-[28%]
    bg-gradient-to-t
    from-[#f7f6f1]
    via-[#f7f6f1]/95
    via-[#f7f6f1]/65
    to-transparent
    z-20
    pointer-events-none
  "
/>

</div>
    {/* LEFT TEXT */}
    <div className="relative space-y-6 text-left z-20 md:-mt-40">

     <div className="
  mb-6
  text-[12px]
  tracking-[0.32em]
  uppercase
  text-[#5b6f00]/80
  font-semibold
">
  PLAN • MANAGE • SHARE • TRAVEL
</div>

<h1 className="
  font-serif
  text-[78px]
  leading-[0.92]
  tracking-[-0.06em]
  font-medium
  text-[#1b2718]
">
  Your next trip,
  <br />

  <span className="text-[#5b6f00] italic">
    beautifully
  </span>

  <br />

  <span className="text-[#5b6f00] italic">
    organized.
  </span>
</h1>

<p className="
  mt-7
  text-[22px]
  leading-[1.6]
  text-[#4b5563]
  max-w-[560px]
  font-medium
">
  AI-powered itineraries, smart planning,
  and beautiful trips your friends actually
  want to join.
</p>

      <button
       onClick={() => {
  const yOffset = window.innerWidth < 768 ? -60 : -80;
  const y =
    formCardRef.current.getBoundingClientRect().top +
    window.pageYOffset +
    yOffset;

  window.scrollTo({ top: y, behavior: "smooth" });
}}
        className="rounded-full bg-[#5b6f00] px-10 py-4 text-white font-bold 
        hover:scale-105 active:scale-95 transition-all duration-300 
        shadow-[0_10px_30px_rgba(91,111,0,0.25)] flex items-center gap-3"
      >
        Start My Trip
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
      </button>

      <div className="flex items-center gap-4 mt-8">
         {/* <div className="flex -space-x-3">
             <img src="https://i.pravatar.cc/100?img=1" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" alt="user" />
             <img src="https://i.pravatar.cc/100?img=2" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" alt="user" />
             <img src="https://i.pravatar.cc/100?img=3" className="w-10 h-10 rounded-full border-2 border-white shadow-sm" alt="user" />
         </div> */}

        {/* Text */}
        <p className="text-sm text-[#6b7280]">
          <span className="font-semibold text-[#1f2d1f]">2.4k+ trips shared</span> this month.
        </p>

</div>

    </div>

    {/* RIGHT SIDE WITH FLOATING IMAGE + FORM */}
    <div className="relative flex justify-end">

      <div className="relative w-full max-w-xl">

        <div className="absolute -left-40 top-1/2 -translate-y-1/2 z-0">
          <div className="absolute inset-0 -m-20 bg-[#5b6f00]/10 rounded-full blur-[100px]" />

          <div className="relative w-[420px] h-[600px] rounded-[220px] overflow-hidden shadow-[0_30px_70px_rgba(0,0,0,0.08)]">
            <img
              src={heroImage}
              alt="Travel Destination"
              className="w-full h-full object-cover scale-x-[-1]"
            />
            <div
  className="
    absolute
    inset-0
    bg-gradient-to-r
    from-[#f7f6f1]/10
    via-transparent
    to-[#f7f6f1]/70
  "
/>
          </div>
          
          {/* Travel Energy Indicators */}
          {/* <div className="absolute bottom-20 -left-6 bg-white/95 backdrop-blur-md px-5 py-4 rounded-3xl shadow-2xl flex items-center gap-4 border border-white/50 transform hover:scale-105 transition-transform duration-500 z-30">
            <div className="w-10 h-10 rounded-full bg-[#5b6f00]/10 flex items-center justify-center text-xl shadow-inner">
              🌅
            </div>
            <div>
              <p className="text-[10px] font-bold text-[#5b6f00] uppercase tracking-widest">Atmosphere</p>
              <p className="text-sm font-black text-gray-900">Sunset at 6:42 PM</p>
            </div>
          </div>

          <div className="absolute top-32 -right-8 bg-white/95 backdrop-blur-md px-5 py-4 rounded-3xl shadow-2xl flex items-center gap-4 border border-white/50 transform hover:scale-105 transition-transform duration-500 delay-100 z-30">
            <div className="w-10 h-10 rounded-full bg-[#5b6f00]/10 flex items-center justify-center text-xl shadow-inner">
              🌤
            </div>
            <div>
              <p className="text-[10px] font-bold text-[#5b6f00] uppercase tracking-widest">Local Insight</p>
              <p className="text-sm font-black text-gray-900">Rooftop weather tonight</p>
            </div>
          </div> */}
        </div>

        <div className="relative z-20">
          <PlanPage
            formCardRef={formCardRef}
            handleSubmit={handleSubmit}
            tripType={tripType}
            setTripType={setTripType}
            hours={hours}
            setHours={setHours}
            days={days}
            setDays={setDays}
            multiStartDate={multiStartDate}
            setMultiStartDate={setMultiStartDate}
            place={place}
            setPlace={setPlace}
            group={group}
            setGroup={setGroup}
            suggestions={suggestions}
            setSuggestions={setSuggestions}
            addSuggestion={addSuggestion}
            loading={loading}
            citySuggestions={citySuggestions}
            showSuggestions={showSuggestions}
            setShowSuggestions={setShowSuggestions}
            tripDate={tripDate}
            setTripDate={setTripDate}
          />
        </div>

      </div>
    </div>
  </div>
</div>

{ENABLE_CREATOR_DASHBOARD && <CreatorDashboardSection />}

            {/* LOWER SECTIONS */}
            <FeatureCards onNavigate={(path) => navigate(path)} />
{currentUser && (
  <div className="max-w-6xl mx-auto px-6 mt-24">
    <TripsDashboard compact />
  </div>
)}
            <ItinerarySlider
              onItineraryClick={(slug) => {
                navigate(`/itineraries/${slug}`);
              }}
            />
            <CitySlider onCityClick={(slug) => navigate(`/cities/${slug}`)} />
            
            <div className="mt-16 md:mt-24">
              <div className="py-12 md:py-20 px-6 text-center">
                <div className="max-w-3xl mx-auto space-y-6 md:space-y-8">
                  <div className="w-16 h-1 bg-black/30 mx-auto rounded-full" />
                  <h2 className="text-2xl md:text-4xl font-serif text-[#1f2d1f] leading-tight">
                    You too can earn while on the move
                  </h2>
                  <button
                    onClick={() => navigate("/become-guide")}
                    className="w-full md:w-auto inline-flex items-center justify-center rounded-full bg-[#5b6f00] px-10 py-4 text-white text-lg font-semibold hover:scale-105 transition-all shadow-lg hover:shadow-xl"
                  >
                    Become a local guide
                  </button>
                </div>
              </div>
            </div>
            <AiFeedbackBanner source="AI Planner" />
            <FaqFooterSection />
            {/* <Footer /> */}
          </>
        }
        formCardRef={formCardRef}
        handleSubmit={handleSubmit}
        tripType={tripType}
        setTripType={setTripType}
        hours={hours}
        setHours={setHours}
        days={days}
        setDays={setDays}
        multiStartDate={multiStartDate}
        setMultiStartDate={setMultiStartDate}
        place={place}
        setPlace={setPlace}
        group={group}
        setGroup={setGroup}
        suggestions={suggestions}
        setSuggestions={setSuggestions}
        addSuggestion={addSuggestion}
        loading={loading}
        apiStatus={apiStatus}
        citySuggestions={citySuggestions}
        showSuggestions={showSuggestions}
        setShowSuggestions={setShowSuggestions}
        tripDate={tripDate}
        setTripDate={setTripDate}
      />
    </div>
    
  );


}

export default App;   